module.exports = __webpack_public_path__ + "static/hero-succession-64c20f8228d260c761d048c97fa5cc79.svg";